import { RoleTypeEnum } from '@cyberlabrs/helpers';

export const AUTHORIZED = [RoleTypeEnum.OWNER, RoleTypeEnum.ADMIN, RoleTypeEnum.PM, RoleTypeEnum.TEAM_LEAD, RoleTypeEnum.ORDINARY, RoleTypeEnum.HR];

export const AUTHORIZED_ADMIN_OWNER = [RoleTypeEnum.ADMIN, RoleTypeEnum.OWNER];

export const AUTHORIZED_TEAM_SUB_TEAMS_ORG = [RoleTypeEnum.OWNER, RoleTypeEnum.ADMIN, RoleTypeEnum.TEAM_LEAD];

export const AUTHORIZED_ADMIN_OWNER_HR = [RoleTypeEnum.ADMIN, RoleTypeEnum.OWNER, RoleTypeEnum.HR];

export const AUTHORIZED_ADMIN_OWNER_PM = [RoleTypeEnum.ADMIN, RoleTypeEnum.OWNER, RoleTypeEnum.PM];

export const AUTHORIZED_PM_TEAM_LEAD = [RoleTypeEnum.PM, RoleTypeEnum.TEAM_LEAD];

export const AUTHORIZED_ADMIN_OWNER_HR_PM = [RoleTypeEnum.ADMIN, RoleTypeEnum.OWNER, RoleTypeEnum.HR, RoleTypeEnum.PM];

export const AUTHORIZED_ADMIN_OWNER_HR_PM_TEAM_LEAD = [
    RoleTypeEnum.OWNER,
    RoleTypeEnum.ADMIN,
    RoleTypeEnum.PM,
    RoleTypeEnum.TEAM_LEAD,
    RoleTypeEnum.HR,
];

export const AUTHORIZED_ADMIN_OWNER_HR_TEAM_LEAD = [RoleTypeEnum.OWNER, RoleTypeEnum.ADMIN, RoleTypeEnum.TEAM_LEAD, RoleTypeEnum.HR];

export const AUTHORIZED_BASIC_ORDINARY_TEAM_LEAD_HR = [RoleTypeEnum.BASIC, RoleTypeEnum.ORDINARY, RoleTypeEnum.TEAM_LEAD, RoleTypeEnum.HR];

export const AUTHORIZED_BASIC_ORDINARY_TEAM_LEAD_HR_PM = [
    RoleTypeEnum.BASIC,
    RoleTypeEnum.ORDINARY,
    RoleTypeEnum.TEAM_LEAD,
    RoleTypeEnum.HR,
    RoleTypeEnum.PM,
];

export const AUTHORIZED_ORDINARY_TEAM_LEAD_PM_HR = [RoleTypeEnum.ORDINARY, RoleTypeEnum.TEAM_LEAD, RoleTypeEnum.PM, RoleTypeEnum.HR];
